<app-menu [hasChanges]="loadMenu" [title]="'Listado de movimientos - Ecommerce'"></app-menu>
<app-loading [show]="load"></app-loading>
<section class="min-h-screen p-2-pr-2">
    <div class="flex flex-wrap w-full mt-3 p-3 bg-gray-50 gap-2 align-items-end justify-content-center">
        <div class="gap-2 p-2">
            <label class="uppercase">Seleccione un rango de fechas de consulta</label>
            <p-datepicker [(ngModel)]="rangeDates" [showWeek]="false" appendTo="body" #calendar selectionMode="range"
                [readonlyInput]="true" dateFormat="yy-mm-dd" [showIcon]="true" [styleClass]="'w-full'"
                (onSelect)="onSelectDate($event)"></p-datepicker>
        </div>
        <div class="pb-2"><button pButton icon="pi pi-search" label="Buscar" (click)="getInfo()"
                class="p-button p-button-success"></button></div>
    </div>
    <div class="border-top-2 border-300 flex flex-wrap w-full pt-2 pb-2">
        <div class="md:w-3 text-center"><b>Inf.Cotización</b></div>
        <div class="md:w-3 text-center"><b>Cliente</b></div>
        <div class="md:w-3 text-center"><b>Inf. Facturación</b></div>
        <div class="md:w-3 text-center"><b>Inf. Entrega</b></div>

    </div>
    <div class="border-top-2 border-300 flex flex-wrap w-full pt-2 pb-3" *ngFor="let item of items">
        <div class="md:w-3 text-left pl-4">
            <p><b>Nro. de venta:</b> {{item.id}} <i class="pi pi-eye cursor-pointer"
                    (click)="viewDetail(item.detail)"></i><br>
                <b>Fecha de creación:</b> {{item.creationDate | date:'medium'}}<br>
                <b>Fecha de pago:</b> {{item.updateDate | date:'medium'}}<br>
                <b>Total venta:</b> {{item.subtotal + item.taxes | currency}}<br>
                <b>Total envío:</b> {{item.shippingCost | currency}}<br>
                <b>Estado: {{item.statusIntegration}}</b> <span *ngIf="item.statusIntegration == 'Pago Recibido'"
                    [innerHTML]="'&#x270C;'"></span>
            </p>
        </div>

        <div class="md:w-3 text-left pl-2s">
            <p><b>Tipo:</b> {{item.documentType}}<br>
                <b>Identificación:</b> {{item.identification}}<br>
                <b>Razón Social:</b> {{item.companyName}}<br>
                <b>Contacto:</b> {{item.contact}}
            </p>
        </div>
        <div class="md:w-3 text-left pl-2">
            <p><b>Email:</b> {{item.billingEmail}}<br>
                <b>Dirección:</b> {{item.billingAddress}}<br>
                <b>Ciudad:</b> {{item.billingCity}}<br>
            </p>
        </div>
        <div class="md:w-3 text-left p-l2">
            <p><b>Contacto:</b> {{item.shippingContact}}<br>
                <b>Email:</b> {{item.shippingEmail}}<br>
                <b>Teléfono:</b> {{item.shippingPhone}}<br>
                <b>Dirección:</b> {{item.shippingAddress}}<br>
                <b>Complemento:</b> {{item.shippingComplement}}<br>
                <b>Ciudad:</b> {{item.shippingcity}}
            </p>
        </div>

    </div>
    <div class="fixed bottom-0 mt-4 w-full text-center">
        <div class="w-full" *ngIf="items.length > 0">
            <button pButton class="p-button p-button-success"
                icon="pi {{!viewResumen ? 'pi-chevron-up': 'pi-chevron-down'}}" label="RESUMEN"
                (click)="viewResumen= !viewResumen"></button>
        </div>
        <div class="mx-auto w-full flex flex-wrap bg-white justify-content-center pt-3 pb-2" *ngIf="viewResumen">
            <div class="text-center w-full md:w-6 p-4">
                <h4 class="text-uppercase m-0"><b>Total</b></h4>
                # de items : {{items.length}} |
                Subtotal : {{totales.subtotal | currency}} |
                Impuesto: {{totales.taxes | currency}}|
                Costo envio: {{totales.shippingCost | currency}}|<br>
                <b>TOTAL: {{(totales.subtotal + totales.taxes + totales.shippingCost) | currency}} </b>
            </div>

            <div class="text-center w-full md:w-6 p-4">
                <h4 class="text-uppercase m-0"><b>Ventas Exítosas {{((totalesSuccess.subtotal + totalesSuccess.taxes +
                        totalesSuccess.shippingCost)/(totales.subtotal + totales.taxes + totales.shippingCost)) |
                        percent: '.2-2'}}</b>
                </h4>
                # de items : {{itemsSuccess.length}} |
                Subtotal : {{totalesSuccess.subtotal | currency}} |
                Impuesto: {{totalesSuccess.taxes | currency}}|
                Costo envio: {{totalesSuccess.shippingCost | currency}}|<br>
                <b>TOTAL: {{(totalesSuccess.subtotal + totalesSuccess.taxes + totalesSuccess.shippingCost) | currency}}
                </b>
            </div>
        </div>
    </div>
</section>

<p-dialog header="Información Venta" [modal]="true" [(visible)]="displayDetail" [style]="{width: '90vw'}"
    [baseZIndex]="10000">
    <div class="mt-3 grid hidden md:flex" *ngIf="detail.length > 0">
        <div class="col-5 text-center">PRODUCTO</div>
        <div class="col-2 text-center">CANTIDAD</div>
        <div class="col-5 text-center">TOTAL</div>
    </div>
    <div class="mt-3 grid" *ngFor="let row of detail; let $index =index">
        <div class="col-12 md:col-1 text-center">Item {{$index +1}}</div>
        <div class="col-12 md:col-4 text-center"><b>{{row.codBarras}}&nbsp;{{row.description}}</b> <br>
        </div>
        <div class="col-12 md:col-2 text-center"><span class="p-d-md-none">Cantidad: </span>{{row.quantity}}</div>
        <div class="col-12 md:col-5 text-center">Subtotal : {{row.subtotal | currency}} <br>
            Impuesto: {{row.taxes | currency}}<br>
            <b>TOTAL: {{(row.subtotal + row.taxes) | currency}}</b>
        </div>
        <div class="col-12">
            <hr>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-times-circle" (click)="displayDetail=false" label="Cerrar"
            styleClass="p-button p-button-error p-button-text"></p-button>
    </ng-template>
</p-dialog>